import { Component, OnInit } from '@angular/core';
import { UserProfile } from '../../../models/user-profile.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserProfileService } from '../../../services/user-profile.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { ValidateNotEmpty } from '../../../validators/validate-not-empty';
import { salutations } from '../../../models/salutations.model';
import { MatDialog } from '@angular/material/dialog';
import { HelpService } from '@services/help.service';

@Component({
    selector: 'lex-user-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {

	userProfile: UserProfile;
	userProfileForm: UntypedFormGroup;
	inEdit = false;
	isUserProfileComplete = true;
	salutations = salutations;

	constructor(
		private userProfileService: UserProfileService,
		private formBuilder: UntypedFormBuilder,
		private snackBar: MatSnackBar,
		private authenticationService: AuthenticationService,
		private router: Router,
		private dialog: MatDialog,
		private helpService: HelpService
	) {
		this.helpService.updateHelpLinkUrl('https://sites.google.com/a/ediscoveryplatform.com/help/home/help/management-menu/user-profile');
	}

	ngOnInit(): void {
		this.userProfileService.getUserProfile(this.authenticationService.getUserId())
			.subscribe((up: UserProfile) => {
				this.initializeForm(up);
			});
	}

	private initializeForm(userProfile: UserProfile): void {
		this.userProfile = userProfile;
		this.userProfileForm = this.formBuilder.group({
			salutation: [this.userProfile.salutation],
			firstName: [this.userProfile.firstName, [Validators.maxLength(256), ValidateNotEmpty]],
			lastName: [this.userProfile.lastName, [Validators.maxLength(256), ValidateNotEmpty]],
			organization: [this.userProfile.organization, Validators.maxLength(256)]
		});


		if (this.isNullOrSpaces(this.userProfile.firstName)
			|| this.isNullOrSpaces(this.userProfile.lastName)) {
			this.isUserProfileComplete = false;
			this.inEdit = true;
			this.snackBar.open('Please fill out your contact information before continuing.');
		}
	}

	private isNullOrSpaces(s: string): boolean {
		return s === null || s.match(/^ *$/) !== null;
	}

	onSubmit() {
		this.fillProfileFromForm();
		// Validation
		if (this.userProfileForm.invalid) {
			this.snackBar.open('Please address the user profile details before saving.');
			return;
		}

		this.userProfileService.updateUserProfile(this.userProfile).subscribe(() => {
			this.snackBar.dismiss();
			this.inEdit = false;
			if (!this.isUserProfileComplete)
				this.router.navigate(['/']);
		});
	}

	onCancel() {
		this.inEdit = false;
	}

	onEdit() {
		this.inEdit = true;
	}

	fillProfileFromForm() {
		this.userProfile.salutation = this.userProfileForm.value.salutation;
		this.userProfile.firstName = this.userProfileForm.value.firstName;
		this.userProfile.lastName = this.userProfileForm.value.lastName;
		this.userProfile.organization = this.userProfileForm.value.organization;
	}
}
